import { render, staticRenderFns } from "./order.form.vue?vue&type=template&id=5fae45f6&"
import script from "./order.form.vue?vue&type=script&lang=js&"
export * from "./order.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports